<template>
    <Checkout current-page="Install and Monitoring">
        <section class="checkoutMonitoring">
            <h2>Scheduling your install.</h2>
            <p>
                Installation is scheduled over the phone. During your installation call, we will help you cover some important stuff. Here is a checklist.
            </p>

            <div class="schedulingChecklist">
                <div class="schedulingChecklist-item">
                    <img src="/img/checkmark-gray.png"
                         alt="Checkmark"
                         class="schedulingChecklist-icon">
                    <span class="key">Set</span> a date and time.
                </div>
                <div class="schedulingChecklist-item">
                    <img src="/img/checkmark-gray.png"
                         alt="Checkmark"
                         class="schedulingChecklist-icon">
                    <span class="key">Confirm</span> your package and monitoring plan.
                </div>
                <div class="schedulingChecklist-item">
                    <img src="/img/checkmark-gray.png"
                         alt="Checkmark"
                         class="schedulingChecklist-icon">
                    <span class="key">Provide</span> emergency contact information.
                </div>
            </div>

            <div class="afterChecklist">To schedule your install complete the checkout process.</div>

            <!-- ASAP INSTALLATION -->
            <section class="asapInstall">
                <div>
                    <i class="fa fa-calendar-check-o" />
                </div>
                <div>
                    <div class="text">Interested in same day or next day installation?</div>
                    <a href="javascript:;" @click="askAboutAsapInstall">Check availability</a>
                </div>
            </section>

            <div class="checkoutActions">
                <continue-button to="/assessment/checkout/personal-information"
                                 :before="mixpanelTracking"
                                 text="Continue with checkout" />
            </div>
        </section>
    </Checkout>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import Checkout from './Checkout.vue'
export default {
    computed: {
        ...mapState([])
    },
    methods: {
        ...mapActions([
            'askAboutAsapInstall'
        ]),
        mixpanelTracking() {
            mixpanel.track("checkoutStep1Complete")
        }
    },
    mounted() {
        mixpanel.track("beganCheckout")
    },
    components: {
        Checkout
    }
}
</script>

<style lang="css"></style>
